import useHealthTraitsPredictions from 'hooks/useHealthTraitsPredictions';
import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export interface UseHealthFeatureOptions {
  redirectTo?: string;
  skipRedirect?: boolean
}

const useHealthFeature = ({ redirectTo, skipRedirect = false }: UseHealthFeatureOptions = {}) => {
  const navigate = useNavigate();
  const { testId, traitId } = useParams();
  const {
    traits, loading, entitled, petProfile, breedResults,
  } = useHealthTraitsPredictions();

  useEffect(() => {
    if (!entitled && !loading && !skipRedirect) {
      navigate(redirectTo ?? `/${testId ?? ''}`);
    }
  }, [navigate, entitled, loading, redirectTo, testId, skipRedirect]);

  return useMemo(() => ({
    loading,
    petProfile,
    breedResults,
    predictions: traits,
    prediction: traitId
      ? traits?.find((t) => t.id.toLowerCase() === traitId.toLowerCase())
      : undefined,
  }), [petProfile, breedResults, traits, traitId, loading]);
};

export default useHealthFeature;
